import * as firebase from "firebase";
import _ from "lodash";
import { dateToStringFormat } from "../utils/Utils";

export const FETCH_SLIDES = "fetch_slides";
export const FETCH_SLIDES_SUCCESS = "fetch_slides_success";

export const ADD_SLIDE = "add_slide";
export const ADD_SLIDE_SUCCESS = "add_slide_success";
export const ADD_SLIDE_FAIL = "add_slide_fail";

export const DELETE_SLIDE = "delete_slide";
export const DELETE_SLIDE_SUCCESS = "delete_slide_sucess";
export const DELETE_SLIDE_FAIL = "delete_slide_fail";

export function fetchAllSlides() {
  const slidesRef = firebase.database().ref("slideshows");

  return (dispatch) => {
    dispatch({ type: FETCH_SLIDES });

    slidesRef.on("value", (snapshot) => {
      const value = snapshot.val();
      console.log("slidesRef", snapshot.numChildren());
      if (value) {
        let rawSlides = [];
        snapshot.forEach((rawSlide) => {
          const slideId = rawSlide.key;
          const slide = rawSlide.val();

          rawSlides.push({ ...slide, slideId: slideId });
        });

        const sorted = _.sortBy(rawSlides, (s) => {
          return s.order;
        });

        dispatch({
          type: FETCH_SLIDES_SUCCESS,
          payload: value,
          sorted: sorted,
        });
      }
    });
  };
}

export function addSlide(imageFiles, progressCallback, finishCallback) {
  const slideRef = firebase
    .database()
    .ref("slideshows")
    .push();
  return (dispatch) => {
    dispatch({ type: ADD_SLIDE });

    if (imageFiles) {
      console.log("imageFiles", imageFiles);
      const id = slideRef.key;
      performUpload(
        // upload image to storage
        {
          file: imageFiles,
          uploadPath: "public/images/slideshows",
          namePrefix: dateToStringFormat() || "000000",
          id,
        },
        (progress) => {
          if (progressCallback) {
            console.log("progressCallback:", progress);
          }
        },
        (uploadFile) => {
          console.log("callback", uploadFile);
          writeSlideToDatabase(
            { banner: imageFiles.name, slideId: id },
            uploadFile,
            dispatch,
            finishCallback
          );
        }
      );
    }
  };
}

function writeSlideToDatabase(
  { banner, slideId },
  uploadedImage,
  dispatch,
  callback
) {
  const productRef = firebase
    .database()
    .ref("slideshows")
    .child(slideId);

  let updateBanner = banner;
  updateBanner = {
    ...banner,
    image_paths: uploadedImage.url,
  };

  productRef.update(updateBanner, (error) => {
    if (error) {
      dispatch({
        type: ADD_SLIDE_FAIL,
      });
    } else {
      dispatch({
        type: ADD_SLIDE_SUCCESS,
      });
    }

    if (callback) {
      callback();
    }
  });
}

export function deleteSlide(id, callback) {
  return (dispatch) => {
    dispatch({
      type: DELETE_SLIDE,
    });

    const productRef = firebase
      .database()
      .ref("slideshows")
      .child(id);
    productRef
      .remove()
      .then(() => {
        dispatch({ type: DELETE_SLIDE_SUCCESS });

        if (callback) {
          callback(true);
        }
      })
      .catch((error) => {
        dispatch({
          type: DELETE_SLIDE_FAIL,
          payload: error.message,
        });

        if (callback) {
          callback(false);
        }
      });
  };
}

function performUpload(
  { file, uploadPath, namePrefix, dbProductId },
  progressCallback,
  finishCallback
) {
  // get file extensions
  // put it in file name
  // also put it in database-> image_name
  console.log("performUpload", file);
  const extension = file.name.split(".").pop();
  const fileName = `${namePrefix}_${Date.now()}.${extension}`;
  const metadata = {
    customMetadata: {
      productId: dbProductId,
    },
  };
  console.log("performUpload");
  const bucketRef = firebase
    .storage()
    .ref()
    .child(uploadPath);
  const fileRef = bucketRef.child(fileName);
  let uploadTask = fileRef.put(file, metadata);

  uploadTask.on(
    firebase.storage.TaskEvent.STATE_CHANGED,
    (snapshot) => {
      // Get task progress, including the number of bytes uploaded and the total number of bytes to be uploaded
      const progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;

      console.log("Upload is " + progress + "% done");
      if (progressCallback) {
        progressCallback(progress);
      }

      switch (snapshot.state) {
        case firebase.storage.TaskState.PAUSED: // or 'paused'
          console.log("Upload is paused");
          break;
        case firebase.storage.TaskState.RUNNING: // or 'running'
          console.log("Upload is running");
          break;
      }
    },
    (error) => {
      console.log("error:", error);
      // A full list of error codes is available at
      // https://firebase.google.com/docs/storage/web/handle-errors
      switch (error.code) {
        case "storage/unauthorized":
          // User doesn't have permission to access the object
          break;

        case "storage/canceled":
          // User canceled the upload
          break;

        case "storage/unknown":
          // Unknown error occurred, inspect error.serverResponse
          break;
      }

      if (finishCallback) {
        console.log("finishCallback !!");
        finishCallback(null, error);
      }
    },
    () => {
      console.log("Upload completed successfully");
      // Upload completed successfully, now we can get the download URL
      if (finishCallback) {
        finishCallback({
          fileName,
          url: uploadTask.snapshot.downloadURL,
        });
      }
      // addFilePath(sessionId, file.name, fileRef.fullPath);
    }
  );
}



// WEBPACK FOOTER //
// ./src/actions/Slideshow.js